<app-notifications class="full-width" [showAll]="false" (closeNotifications)="close($event)"></app-notifications>
